import _ from 'lodash';

function LocationCtrl($http, $rootScope, $scope, $state, $timeout, $interval, toastr, AppSettings, ChartGeneratorService, LocationService, PlanService, PlayerService) {
  'ngInject';

  /**
   * Variables
   */

  window['scope'] = $scope;
  window['d3'] = d3;

  // ViewModel
  const vm = this;

  // sidebar 초기화
  $rootScope.$emit('base:sidebarEvent', 'off');

  //현재 page명 세팅
  $scope.$parent.base.pageStatus = 'teamLocation';

  vm.gameInfoData = $scope.$parent.base.gameInfoData;
  vm.gameResultData = $scope.$parent.base.gameResultData;
  vm.trainingResult = $scope.$parent.base.trainingResult;

  vm.showMapSelectBox = false; // 맵 선택상자 보이기
  vm.showMovieSelectBox = false; // 동영상 선택상자 보이기
  vm.showRealtimeSelectBox = false; // 실시간 동영상 선택상자 보이기
  vm.showToolSelectBox = false; // 분석툴 선택상자 보이기

  vm.showHeatmap = true; // 히트맵 보이기
  vm.showTracking = false; // 트래킹 보이기
  vm.showLinkmap = false; // 연결도 보이기
  vm.showMovie = false; // 동영상 보이기
  vm.showRealtime = false; // 실시간 동영상 보이기
  vm.showTool = false; // 분석툴 보이기

  vm.skillIndex = 0; // 동작 index

  // 경기를 시작하지 않고 접근하면 경기기록 페이지로 이동시킴
  if (!vm.gameInfoData.game_id) {
    toastr.error('해당일에 경기 및 훈련 기록정보가 없습니다.');
  }

  vm.userInfo = $rootScope.userInfo;
  let userBasicInfo = {
    login_id: $rootScope.userInfo.login_id,
    uuid: $rootScope.userInfo.uuid
  };

  const h337 = require('heatmap.js');
  let heatmapInstance;
  vm.mainCategories1 = ['heartbeat', 'oxygen', 'lactic', 'temperature'];
  vm.mainCategories2 = ['distance', 'velocity', 'calory', 'weight', 'injury'];
  vm.mainCategory1 = null;
  vm.subCategory1 = null;
  vm.mainCategory2 = null;
  vm.subCategory2 = null;

  let trackingChartInstance;
  let trackingChartTimer;


  vm.pageLoad = function () {

    vm.gameInfoData = $scope.$parent.base.gameInfoData;
    vm.gameResultData = $scope.$parent.base.gameResultData;

    vm.entry = [{ // 우리팀 선수
      name: '팀 전체'
    }];
    vm.selectedPlayer = vm.entry[0]; // 선택된 선수
    vm.oppoEntry = [{ // 상대팀 선수
      name: '팀 전체'
    }];
    vm.selectedOppoPlayer = vm.oppoEntry[0]; // 선택된 상대팀 선수

    // 우리팀 선수 명단 불러오기 시작
    let entryParams = {
      login_id: userBasicInfo.login_id,
      uuid: userBasicInfo.uuid,
      game_id: vm.gameInfoData.game_id,
      status: 'IN'
    };

    PlanService.getEntry(entryParams).then(function (data) {
      if (data.result == 'SUC') {
        if (data.players.length) {
          vm.entry = vm.entry.concat(data.players);
        }
      }
    });
    // 우리팀 선수 명단 불러오기 끝

    // 상대팀 선수 명단 불러오기 시작
    let oppoEntryParams = {
      login_id: userBasicInfo.login_id,
      uuid: userBasicInfo.uuid,
      game_id: vm.gameInfoData.game_id,
      status: 'IN',
      is_oppo: 'Y'
    };

    PlanService.getEntry(oppoEntryParams).then(function (data) {
      if (data.result == 'SUC') {
        if (data.players.length) {
          vm.oppoEntry = vm.oppoEntry.concat(data.players);
        }
      }
    });
    // 상대팀 선수 명단 불러오기 끝

  };

  /**
   * custom event handller
   */
  $scope.$on('base.gameResultData', function (e) {
    // start
    vm.pageLoad();
  });

  vm.drawStatusBarChart = function () {

    let entryParams = {
      login_id: userBasicInfo.login_id,
      uuid: userBasicInfo.uuid,
      game_id: vm.gameInfoData.game_id,
      status: 'IN'
    };

    // LocationService.getHomeTeamTimeline(entryParams).then(function (data) {
    //   // console.log(data);
    //   vm.createBarChartBasic(data, '#home-chart', 'positive');
    // }).catch(function (e) {
    //   console.log('ERROR: ', e)
    // });

    var timeline_team_home = d3.range(90).map(function() {
			return Math.random();
		});
    vm.createBarChartBasic(timeline_team_home, '#home-chart', 'positive');

    // LocationService.getAwayTeamTimeline(entryParams).then(function (data) {
    //   vm.createBarChartBasic(data, '#away-chart', 'negative');
    // }).catch(function (e) {
    //   console.log('ERROR: ', e)
    // });
    var timeline_team_away = d3.range(90).map(function() {
			return Math.random();
		});
    vm.createBarChartBasic(timeline_team_away, '#away-chart', 'negative');

  };

  vm.createBarChartBasic = function (data, targetId, type) {


    // console.log('render bar chart.......')
    var bar = targetId + ' .bar';
    d3.selectAll(bar).remove();

    let height = 30;
    let width = 1000;
    let barPadding = 2;
    let barWidth = (width / data.length) - barPadding;

    let yScale = d3.scale.linear().domain([0, d3.max(data)]).range([0, height]);
    let xScale = d3.scale.ordinal().domain(data).rangeBands([0, width], 0.1, 0.3);

    let svg = d3.select(targetId)
      .style("width", width + 'px')
      .style("height", height + 'px');

    svg.selectAll('rect')
      .data(data)
      .enter()
      .append('rect')
      .on('click', function (d, index) {
        d3.selectAll('.bar').style("fill", "green");
        d3.select(this).style("fill", "magenta");
        console.log('000000>>>>> ', d, index, targetId);
        vm.drawTimelineHeatmap(index);
      })
      .attr('class', 'bar')
      .attr("x", function (d, i) {
        return xScale(d);
      })
      .attr("y", function (d, i) {
        return height;
      })
      .attr("width", function (d, i) {
        return xScale.rangeBand();
      })
      .attr("fill", function (d, i) {
        //  return 'rgb(256, ' + Math.round(i / 2) + ', ' + i + ')';
        return 'green';
      })
      .attr("height", 0)
      .transition()
      .duration(200)
      .delay(function (d, i) {
        return i * 0;
      })
      .attr("y", function (d, i) {
        if (type == 'positive') {
          return height - yScale(d);
        } else {
          return yScale(d) - height;
        }
      })
      .attr("height", function (d, i) {
        if (type == 'positive') {
          return yScale(d);
        } else {
          return height;
        }
      });
  };

  vm.drawTimelineHeatmap = function (index) {
    // LocationService.getTimeLocation().then(function (result) {
    //     vm.drawHeatmap(result, '임시매니져', index);
    //   })
    //   .catch(function (e) {
    //     console.log('ERROR: ', e);
    //   });

    var result = [
      {"id":1
      ,"abbr":"A-CK-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":2
      ,"abbr":"A-PA-CK-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":3
      ,"abbr":"A-PA-OUT-EL-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":4
      ,"abbr":"A-PA-OUT-SD-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":5
      ,"abbr":"A-PA-IN-EL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":6
      ,"abbr":"A-PA-OUT-FR-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":7
      ,"abbr":"A-CK-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":8
      ,"abbr":"A-PA-CK-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":9
      ,"abbr":"A-PA-OUT-EL-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":10
      ,"abbr":"A-PA-OUT-SD-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":11
      ,"abbr":"A-PA-IN-EL-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":12
      ,"abbr":"A-PA-OUT-FR-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":13
      ,"abbr":"A-PA-OUT-FR-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":14
      ,"abbr":"A-PA-IN-FR-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":15
      ,"abbr":"A-PA-IN-FR-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":16
      ,"abbr":"A-PA-IN-FR-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":17
      ,"abbr":"A-GA-IN-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":18
      ,"abbr":"A-GA-IN-EL-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":19
      ,"abbr":"A-GA-IN-EL-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":20
      ,"abbr":"A-GA-IN-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":21
      ,"abbr":"A-GA-IN-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":22
      ,"abbr":"A-GA-IN-GK-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":23
      ,"abbr":"A-GA-IN-GK-C"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":24
      ,"abbr":"A-GA-IN-GK-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":25
      ,"abbr":"A-GA-OUT-FR-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":26
      ,"abbr":"A-GA-OUT-FR-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":27
      ,"abbr":"A-GA-OUT-FR-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":28
      ,"abbr":"A-PK-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":29
      ,"abbr":"A-PK-C"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":30
      ,"abbr":"A-PK-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":31
      ,"abbr":"A-AK-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":32
      ,"abbr":"A-AK-C"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":33
      ,"abbr":"A-AK-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":34
      ,"abbr":"A-AK-TL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":35
      ,"abbr":"A-AK-TL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":36
      ,"abbr":"A-MF-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":37
      ,"abbr":"A-MF-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":38
      ,"abbr":"A-MF-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":39
      ,"abbr":"A-MF-TL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":40
      ,"abbr":"A-MF-TL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":41
      ,"abbr":"A-HL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":42
      ,"abbr":"A-HL-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":43
      ,"abbr":"A-HL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":44
      ,"abbr":"A-HL-TL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":45
      ,"abbr":"A-HL-TL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":46
      ,"abbr":"B-CK-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":47
      ,"abbr":"B-PA-CK-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":48
      ,"abbr":"B-PA-OUT-EL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":49
      ,"abbr":"B-PA-OUT-SD-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":50
      ,"abbr":"B-PA-IN-EL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":51
      ,"abbr":"B-PA-OUT-FR-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":52
      ,"abbr":"B-CK-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":53
      ,"abbr":"B-PA-CK-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":54
      ,"abbr":"B-PA-OUT-EL-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":55
      ,"abbr":"B-PA-OUT-SD-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":56
      ,"abbr":"B-PA-IN-EL-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":57
      ,"abbr":"B-PA-OUT-FR-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":58
      ,"abbr":"B-PA-OUT-FR-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":59
      ,"abbr":"B-PA-IN-FR-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":60
      ,"abbr":"B-PA-IN-FR-C"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":61
      ,"abbr":"B-PA-IN-FR-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":62
      ,"abbr":"B-GA-IN-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":63
      ,"abbr":"B-GA-IN-EL-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":64
      ,"abbr":"B-GA-IN-EL-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":65
      ,"abbr":"B-GA-IN-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":66
      ,"abbr":"B-GA-IN-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":67
      ,"abbr":"B-GA-IN-GK-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":68
      ,"abbr":"B-GA-IN-GK-C"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":69
      ,"abbr":"B-GA-IN-GK-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":70
      ,"abbr":"B-GA-OUT-FR-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":71
      ,"abbr":"B-GA-OUT-FR-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":72
      ,"abbr":"B-GA-OUT-FR-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":73
      ,"abbr":"B-PK-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":74
      ,"abbr":"B-PK-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":75
      ,"abbr":"B-PK-L"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":76
      ,"abbr":"B-AK-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":77
      ,"abbr":"B-AK-C"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":78
      ,"abbr":"B-AK-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":79
      ,"abbr":"B-AK-TL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":80
      ,"abbr":"B-AK-TL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":81
      ,"abbr":"B-MF-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":82
      ,"abbr":"B-MF-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":83
      ,"abbr":"B-MF-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":84
      ,"abbr":"B-MF-TL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":85
      ,"abbr":"B-MF-TL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":86
      ,"abbr":"B-HL-R"
      ,"att": parseInt(Math.random()*10)
      ,"suc": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_suc": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_suc": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":87
      ,"abbr":"B-HL-C"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":88
      ,"abbr":"B-HL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_suc": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":89
      ,"abbr":"B-HL-TL-R"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
      ,
      {"id":90
      ,"abbr":"B-HL-TL-L"
      ,"att": parseInt(Math.random()*10)
      ,"sut": parseInt(Math.random()*10)
      ,"left_att": parseInt(Math.random()*10)
      ,"left_sut": parseInt(Math.random()*10)
      ,"right_att": parseInt(Math.random()*10)
      ,"right_sut": parseInt(Math.random()*10)
      ,"team_att": parseInt(Math.random()*10)
      ,"team_sut": parseInt(Math.random()*10)
      ,"oppo_att": parseInt(Math.random()*10)
      ,"oppo_suc": parseInt(Math.random()*10)
      }
    
    
    ]
  
    vm.drawHeatmap(result, '임시매니져', index);

  };

  vm.selectMap = function (type) {
    switch (type) {
      case 'heatmap':
        vm.showHeatmap = true;
        vm.showTracking = false;
        vm.showLinkmap = false;
        vm.showMovie = false;
        vm.showRealtime = false;
        vm.showTool = false;
        break;

      case 'tracking':
        vm.showHeatmap = false;
        vm.showTracking = true;
        vm.showLinkmap = false;
        vm.showMovie = false;
        vm.showRealtime = false;
        vm.showTool = false;
        break;

      case 'linkmap':
        vm.showHeatmap = false;
        vm.showTracking = false;
        vm.showLinkmap = true;
        vm.showMovie = false;
        vm.showRealtime = false;
        vm.showTool = false;
        break;

      case 'movie':
        vm.showHeatmap = false;
        vm.showTracking = false;
        vm.showLinkmap = false;
        vm.showMovie = true;
        vm.showRealtime = false;
        vm.showTool = false;
        break;

      case 'realtime':
        vm.showHeatmap = false;
        vm.showTracking = false;
        vm.showLinkmap = false;
        vm.showMovie = true;
        vm.showRealtime = false;
        vm.showTool = false;
        break;

      case 'tool':
        vm.showHeatmap = false;
        vm.showTracking = false;
        vm.showLinkmap = false;
        vm.showMovie = false;
        vm.showRealtime = false;
        vm.showTool = true;
        break;
    }

    vm.showMapSelectBox = false;
    vm.showMovieSelectBox = false;
    vm.showRealtimeSelectBox = false;
    vm.showToolSelectBox = false;

    if (!vm.showMovie && $('#movie').attr('src')) {
      $('#movie').attr('src', '');
    }

    if (!vm.showRealtime && $('#realtime').attr('src')) {
      $('#realtime').attr('src', '');
    }
  };

  vm.toggleMapSelectBox = function () {
    vm.showMapSelectBox = !vm.showMapSelectBox;
    vm.showMovieSelectBox = false;
    vm.showRealtimeSelectBox = false;
    vm.showToolSelectBox = false;
  };

  vm.toggleMovieSelectBox = function () {
    if (!vm.gameResultData.murls || !vm.gameResultData.murls.length) {
      toastr.error('등록된 동영상이 없습니다.');
      vm.showMovieSelectBox = false;
      return;
    }

    vm.showMapSelectBox = false;
    vm.showMovieSelectBox = !vm.showMovieSelectBox;
    vm.showRealtimeSelectBox = false;
    vm.showToolSelectBox = false;
  };

  vm.toggleRealtimeSelectBox = function () {
    vm.showMapSelectBox = false;
    vm.showMovieSelectBox = false;
    vm.showRealtimeSelectBox = !vm.showRealtimeSelectBox;
    vm.showToolSelectBox = false;
  };

  vm.toggleToolSelectBox = function () {
    vm.showMapSelectBox = false;
    vm.showMovieSelectBox = false;
    vm.showRealtimeSelectBox = false;
    //vm.showToolSelectBox = !vm.showToolSelectBox;
  };

  // showTracking 변경시
  $scope.$watch('location.showTracking', function (newVal, oldVal) {
    if (newVal) {
      // tracking 차트 그리기
      trackingChartInstance = $('#tracking-chart').highcharts();
      if (trackingChartInstance) {
        trackingChartInstance.destroy();
      }

      let width = 1220;
      let height = 880;

      let data1 = [{
          x: 50,
          y: 45,
          z: 10,
          name: '곽태휘'
        },
        {
          x: 26.5,
          y: 72.9,
          z: 10,
          name: '권순태'
        },
        {
          x: 85.8,
          y: 91.5,
          z: 10,
          name: '김진수'
        },
        {
          x: 50.4,
          y: 30.5,
          z: 10,
          name: '기성용'
        },
        {
          x: 30.3,
          y: 80.1,
          z: 10,
          name: '장현수'
        },
        {
          x: 75.4,
          y: 7.1,
          z: 10,
          name: '최철순'
        },
        {
          x: 74.2,
          y: 60.5,
          z: 10,
          name: '한국영'
        },
        {
          x: 33.5,
          y: 83.1,
          z: 10,
          name: '손흥민'
        },
        {
          x: 72,
          y: 23.2,
          z: 10,
          name: '이재성'
        },
        {
          x: 59.2,
          y: 47.6,
          z: 10,
          name: '지동원'
        },
        {
          x: 58.6,
          y: 30,
          z: 10,
          name: '황희찬'
        }
      ];

      Highcharts.chart('tracking-chart', {

        chart: {
          type: 'bubble',
          width: width,
          height: height,
          backgroundColor: 'transparent',
          margin: [0, 25, 0, 25],
          events: {
            load: function () {
              $('#tracking-chart').append('<p class="info">트래킹 화면 데모 시연중</p>');
            }
          }
        },

        credits: {
          enabled: false
        },

        legend: {
          enabled: false
        },

        title: {
          text: ''
        },

        xAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          tickLength: 0
        },

        yAxis: {
          startOnTick: false,
          endOnTick: false,
          gridLineWidth: 0,
          title: {
            enabled: false
          },
          labels: {
            enabled: false
          }
        },

        tooltip: {
          enabled: false,
          useHTML: true,
          headerFormat: '<table>',
          pointFormat: '<tr><th colspan="2"><h3>{point.country}</h3></th></tr>' +
            '<tr><th>Fat intake:</th><td>{point.x}g</td></tr>' +
            '<tr><th>Sugar intake:</th><td>{point.y}g</td></tr>' +
            '<tr><th>Obesity (adults):</th><td>{point.z}%</td></tr>',
          footerFormat: '</table>',
          followPointer: true
        },

        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}'
            },
            marker: {
              fillOpacity: 0.7,
              lineColor: '#333',
              lineWidth: 1
            }
          },
          bubble: {
            maxSize: 40
          }
        },

        series: [{
            color: '#fdcc00',
            data: data1
          }
          // , {
          //   color: '#ffffff',
          //   data: [
          //     { x: 95, y: 95, z: 13.8, name: 'BE', country: 'Belgium' },
          //     { x: 86.5, y: 102.9, z: 14.7, name: 'DE', country: 'Germany' },
          //     { x: 80.8, y: 91.5, z: 15.8, name: 'FI', country: 'Finland' },
          //     { x: 80.4, y: 102.5, z: 12, name: 'NL', country: 'Netherlands' },
          //     { x: 80.3, y: 86.1, z: 11.8, name: 'SE', country: 'Sweden' },
          //     { x: 78.4, y: 70.1, z: 16.6, name: 'ES', country: 'Spain' },
          //     { x: 74.2, y: 68.5, z: 14.5, name: 'FR', country: 'France' },
          //     { x: 73.5, y: 83.1, z: 10, name: 'NO', country: 'Norway' },
          //     { x: 71, y: 93.2, z: 24.7, name: 'UK', country: 'United Kingdom' },
          //     { x: 69.2, y: 57.6, z: 10.4, name: 'IT', country: 'Italy' },
          //     { x: 68.6, y: 20, z: 16, name: 'RU', country: 'Russia' }
          //   ]
          // }
        ]
      });

      if (trackingChartTimer) {
        clearInterval(trackingChartTimer);
        trackingChartTimer = null;
      }
      $rootScope.$on('$stateChangeStart', (event, toState) => {
        if (trackingChartTimer) {
          clearInterval(trackingChartTimer);
          trackingChartTimer = null;
        }
      });
      trackingChartTimer = setInterval(function () {
        let chart = $('#tracking-chart').highcharts();

        _.forEach(data1, function (item) {
          if (Math.random() > 0.5) {
            item.x = item.x + 1;
          } else {
            item.x = item.x - 1;
          }

          if (Math.random() > 0.5) {
            item.y = item.y + 1;
          } else {
            item.y = item.y - 1;
          }
        });

        _.forEach(chart.series[0].data, function (item, i) {
          item.update({
            x: data1[i].x,
            y: data1[i].y
          }, false, false);
        });

        chart.redraw();
      }, 200);
    }
  });

  // game result data 변경시
  $scope.$watch('base.gameResultData', function (newVal, oldVal) {

    // console.log('watch base.gameResultData', newVal);

    if (newVal.locations) {
      // heatmap 그리기 - base.gameResultData
      vm.drawHeatmap(newVal.locations, newVal.name);

      vm.skillIndex = 0;
      vm.displaySkillData();

      // //vm.gamePlayTimer();

      // draw bar chart
      // console.log('draw bar chart')
      vm.drawStatusBarChart();
    }
  });

  // 날짜 변경 시
  $scope.$watch('base.commonData.date', function (newVal, oldVal) {

    if (newVal === oldVal) {
      return;
    }

    // 다른 곳에서도 base.gameResultData 를 변경해서 여기서 약간의 delay 를 두고 실행해서 최종적으로 이 변경이 적용되도록 함
    $timeout(function () {
      $scope.$parent.base.getGameResultLocation(true);

      $timeout(function () {
        vm.pageLoad();
      }, 500);
    }, 500);

  });

  // 선택한 날짜에 경기가 없는 경우 heatmap 처리
  $scope.$on('todayNoGame', function (e) {
    if (heatmapInstance) {
      heatmapInstance.removeData();
      heatmapInstance.setData({
        max: 0,
        data: []
      });
    }
  });

  // 선택된 선수 변경시 (우측 상단에서 우리팀 선수 변경 포함)
  $scope.$watch('location.selectedPlayer', function (newVal, oldVal) {

    // console.log('newVal', newVal)
    if (newVal && newVal.user_id) { // 선수
      $scope.$parent.base.getGameResultLocation(false, newVal.user_id);

      // 생체정보 불러오기
      vm.getPlayerBiometricInfo(newVal.user_id);
    } else if (newVal) { // 팀
      $scope.$parent.base.getGameResultLocation(true);

      if (!vm.selectedPlayer.detailData) {

        vm.selectedPlayer.detailData = {
          movements: angular.copy(vm.gameResultData.movements)
        };
      }

      vm.subCategory1Text = null;
      vm.subCategory1Value = null;
      vm.subCategory1Unit = null;
      vm.subCategory2Text = null;
      vm.subCategory2Value = null;
      vm.subCategory2Unit = null;
    }
  });

  // 우측 상단에서 상대팀 선수 변경시 - 선택된 선수를 변경
  $scope.$watch('location.selectedOppoPlayer', function (newVal, oldVal) {
    if (newVal && newVal.user_id) {
      vm.selectedPlayer = newVal;
    }

    // 상대팀 선택시 처리 해야함
  });

  // 동영상 보기
  vm.viewMovie = function (url) {
    if (!vm.gameResultData.murls || !vm.gameResultData.murls.length) {
      toastr.error('등록된 동영상이 없습니다.');
    } else {
      vm.selectMap('movie');

      $('#movie').attr('src', url);

      vm.showMovieSelectBox = false;
    }
  };

  // 실시간 동영상 보기
  vm.viewRealtime = function (type) {
    vm.selectMap('realtime');

    let url;

    if (type === 'sgs') {
      url = 'https://www.youtube.com/embed/-QLGMUeA6OM';
    }

    $('#movie').attr('src', url);

    vm.showRealtimeSelectBox = false;
  };

  // 채널 보기
  vm.viewChannel = function (type) {
    let channel;

    switch (type) {
      case 'afc':
        channel = 'https://www.youtube.com/channel/UCnj0TjaM0wyxkAWW_nz8_1g';
        break;

      case 'uefa':
        channel = 'https://www.youtube.com/channel/UCyGa1YEx9ST66rYrJTGIKOw';
        break;

      case 'fifa':
        channel = 'https://www.youtube.com/channel/UCpcTrCXblq78GZrTUTLWeBw';
        break;

      case 'caf':
        channel = 'https://www.youtube.com/channel/UCr5K057x3mHroPHsNk9OiwA';
        break;

      case 'concacaf':
        channel = 'https://www.youtube.com/channel/UCqn7r-so0mBLaJTtTms9dAQ';
        break;

      case 'j-league':
        channel = 'https://www.youtube.com/channel/UC7_-7LDcKWCJcEPXCQNzniA';
        break;

      case 'ofc':
        channel = 'https://www.youtube.com/channel/UC5_ARWRWjWNIAyHBAG3eiFQ';
        break;
    }

    window.open(channel);
  };

  // 선수의 생체정보 불러오기
  vm.getPlayerBiometricInfo = function (userId) {
    PlayerService.getPlayerBiometricInfo({
      user_id: userId
    }).then(function (res) {
      vm.selectedPlayer.detailData = res;

      vm.changeMainCategory1();
      vm.changeMainCategory2();

      vm.skillIndex = 0;
      vm.displaySkillData();
    });
  };

  // 선수 목록
  vm.players = [];

  // 기술 변경 함수
  vm.changeSkill = function (direction) {
    let skillsLen = vm.selectedPlayer.detailData.movements.length;

    if (direction) {
      if (direction === 'next') {
        vm.skillIndex = vm.skillIndex + 1;
        if (vm.skillIndex === skillsLen) {
          vm.skillIndex = 0;
        }
      } else if (direction === 'prev') {
        vm.skillIndex = vm.skillIndex - 1;
        if (vm.skillIndex < 0) {
          vm.skillIndex = skillsLen - 1;
        }
      }
    }
    // 화면 처음 실행시
    else {
      vm.skillIndex = 0;
    }

    vm.displaySkillData();
  };

  // heatmap 그리기 함수
  vm.drawHeatmap = function (data, name, index) {
    // console.log('heatmap....', data, name, index);


    if (!heatmapInstance) {

      // console.log('create instance.....');


      heatmapInstance = h337.create({
        container: document.querySelector('.large-heatmap')
      });




      // 최초 실행시에는 heatmap 을 그리지 않음 - game result data 가 우리팀으로 들어오지 않음
      return;
    } else {

      var config;

      if (index > -1) {
        if (index < data.length / 2) {
          // 전반전
          console.log('전반전');
          config = {
            gradient: {
              '.5': 'skyblue',
              '.8': 'brown',
              '.95': 'yellow'
            },
          };
        } else {
          // 후반전
          console.log('후반전');
          config = {
            gradient: {
              '.5': 'blue',
              '.8': 'red',
              '.95': 'white'
            },
          };
        }
      } else {
        // 상단 bar차트 선택 하지 않음.
        console.log('상단 bar차트 선택 하지 않음.');
        config = {
          //defaultGradient: { 0.25: "rgb(0,0,255)", 0.55: "rgb(0,255,0)", 0.85: "yellow", 1.0: "rgb(255,0,0)"},
          gradient: {
            '0.25': 'rgb(0,0,255)',
            '0.55': 'rgb(0,255,0)',
            '0.85': 'yellow',
            '1.0': 'rgb(255,0,0)'
          },
        };

      }

      heatmapInstance.configure(config);


    }



    let width = AppSettings.location.fieldWidth;
    let height = AppSettings.location.fieldHeight;
    let points = [];
    let values = [];
    let maxRadius;
    let maxValue;
    let ratio;

    // name 이 있는 경우 선수, 없으면 팀
    if (name) {
      maxRadius = 100;
    } else {
      maxRadius = 200;
    }

    if (data) {
      _.forEach(data, function (item) {
        let position = LocationService.getPosition(width, height, item.abbr);

        let suc;
        if (name) {
          suc = item.suc;
        } else {
          suc = item.team_suc;
        }

        if (item.team_suc > 0) {
          points.push({
            x: position.x,
            y: position.y,
            value: suc,
            radius: suc
          });

          values.push(suc);
        }
      });

      maxValue = _.max(values);
      ratio = maxRadius / maxValue;

      _.forEach(points, function (item) {
        item.value = item.value * ratio;
        item.radius = item.radius * ratio;
      });

      let locationData = {
        max: maxRadius,
        data: points
      };
      heatmapInstance.removeData();
      heatmapInstance.setData(locationData);
    }
  };

  // 우측 1번째 영역 차트 그리기 함수
  vm.displaySkillData = function () {
    if (!vm.selectedPlayer || !vm.selectedPlayer.detailData) {
      return;
    }

    vm.skillData = vm.selectedPlayer.detailData.movements[vm.skillIndex];

    if (vm.selectedPlayer.user_id) { // 선수
      vm.skillData.success = vm.skillData.suc;
      vm.skillData.right_suc = vm.skillData.right;
      vm.skillData.left_suc = vm.skillData.left;
    } else { // 팀
      vm.skillData.success = vm.skillData.team_suc;
      vm.skillData.total = vm.skillData.team_att;
    }

    let targetId = '#player-skill-main-chart';
    let target = $(targetId);
    let data = vm.skillData;

    target.html('');
    let successPer = (data.success / data.total) * 100;
    if (Number.isNaN(successPer)) {
      successPer = 70;
    }
    let rightPer = (data.right_suc / (data.right_suc + data.left_suc)) * 100;
    if (Number.isNaN(rightPer)) {
      rightPer = 50;
    }

    let dataset = [{
        data: [{
            title: '성공',
            count: successPer //성공
          },
          {
            title: '발',
            count: rightPer //오른발
          }
        ]
      },
      {
        data: [{
            title: '성공',
            count: 100 - successPer //실패
          },
          {
            title: '발',
            count: successPer - rightPer //왼발
          }
        ]
      }
    ];
    let margins = {
      top: 40,
      left: 70,
      right: 40,
      bottom: 40
    };
    ChartGeneratorService.createStackedBarChartHoriz(targetId, dataset, target.width(), target.height(), margins);
  };

  // 우측 2번째 영역 대분류 변경 함수
  vm.changeMainCategory1 = function ($event, mainCategory, direction) {
    let anchor;

    if ($event) {
      anchor = $($event.currentTarget);
    } else {
      let mainCategories1Len = vm.mainCategories1.length;
      let currentMainCategory = $('section.nav-type1').find('ul.main-category').find('li.on').data('category');
      let currentIndex = vm.mainCategories1.indexOf(currentMainCategory);
      let index;

      if (direction === 'next') {
        index = currentIndex + 1;
        if (index === mainCategories1Len) {
          index = 0;
        }
      } else if (direction === 'prev') {
        index = currentIndex - 1;
        if (index < 0) {
          index = mainCategories1Len - 1;
        }
      } else {
        index = 0;
      }

      mainCategory = vm.mainCategories1[index];
      anchor = $('section.nav-type1').find('ul.main-category').find('li').eq(index).find('a');
    }

    anchor.closest('ul').children('li').removeClass('on');
    anchor.parent('li').addClass('on');

    vm.changeSubCategory1(false, 'current', true, mainCategory);
  };

  // 우측 2번째 영역 소분류 변경 함수
  vm.changeSubCategory1 = function ($event, subCategory, setCurrent, mainCategory) {
    let anchors = $('section.nav-type1').find('ul.sub-category').find('a');
    anchors.removeClass('on');

    if (setCurrent) {
      anchors.each(function () {
        if ($(this).text() === '현재') {
          $(this).addClass('on');
        }
      });
    } else {
      let anchor = $($event.currentTarget);
      anchor.addClass('on');

      mainCategory = $('section.nav-type1').find('ul.main-category').find('li.on').data('category');
    }

    vm.mainCategory1 = mainCategory;
    vm.subCategory1 = subCategory;
    drawChart1(mainCategory, subCategory);
  };

  // 우측 2번째 영역 차트 그리기 함수
  function drawChart1(mainCategory, subCategory) {
    if (!vm.selectedPlayer || !vm.selectedPlayer.detailData || !vm.selectedPlayer.detailData.heartbeat) {
      return;
    }

    switch (mainCategory) {
      case 'heartbeat':
        vm.subCategory1Value = vm.selectedPlayer.detailData.heartbeat[0][subCategory];
        vm.subCategory1Unit = (subCategory == 'max' || subCategory == 'stable' || subCategory == 'current') ? 'bpm' : ((subCategory == 'recovery') ? '%' : '초');
        break;

      case 'oxygen':
        vm.subCategory1Value = vm.selectedPlayer.detailData.oxyzen[0][subCategory];
        vm.subCategory1Unit = (subCategory == 'max' || subCategory == 'stable' || subCategory == 'current' || subCategory == 'recovery') ? '%' : '초';
        break;

      case 'lactic':
        vm.subCategory1Value = vm.selectedPlayer.detailData.lactic[0][subCategory];
        vm.subCategory1Unit = (subCategory == 'max' || subCategory == 'stable' || subCategory == 'current') ? 'mg/dℓ' : ((subCategory == 'recovery') ? '%' : '초');
        break;

      case 'temperature':
        vm.subCategory1Value = vm.selectedPlayer.detailData.temperature[0][subCategory];
        vm.subCategory1Unit = (subCategory == 'max' || subCategory == 'stable' || subCategory == 'current') ? '℃' : ((subCategory == 'recovery') ? '%' : '초');
        break;
    }

    switch (subCategory) {
      case 'max':
        vm.subCategory1Text = '최대';
        break;

      case 'stable':
        vm.subCategory1Text = '안정';
        break;

      case 'recovery':
        vm.subCategory1Text = '회복';
        break;

      case 'reach':
        vm.subCategory1Text = '도달';
        break;

      case 'current':
        vm.subCategory1Text = '현재';
        break;
    }
  }

  // 우측 3번째 영역 대분류 변경 함수
  vm.changeMainCategory2 = function ($event, mainCategory, direction) {
    let anchor;

    if ($event) {
      anchor = $($event.currentTarget);
    } else {
      let mainCategories2Len = vm.mainCategories2.length;
      let currentMainCategory = $('section.nav-type2').find('ul.main-category').find('li.on').data('category');
      let currentIndex = vm.mainCategories2.indexOf(currentMainCategory);
      let index;

      if (direction === 'next') {
        index = currentIndex + 1;
        if (index === mainCategories2Len) {
          index = 0;
        }
      } else if (direction === 'prev') {
        index = currentIndex - 1;
        if (index < 0) {
          index = mainCategories2Len - 1;
        }
      } else {
        index = 0;
      }

      mainCategory = vm.mainCategories2[index];
      anchor = $('section.nav-type2').find('ul.main-category').find('li').eq(index).find('a');
    }

    anchor.closest('ul').children('li').removeClass('on');
    anchor.parent('li').addClass('on');

    vm.changeSubCategory2(false, 'current', true, mainCategory);
  };

  // 우측 3번째 영역 소분류 변경 함수
  vm.changeSubCategory2 = function ($event, subCategory, setCurrent, mainCategory) {
    let anchors = $('section.nav-type2').find('ul.sub-category').find('a');
    anchors.removeClass('on');

    if (setCurrent) {
      anchors.each(function () {
        if ($(this).text() === '현재') {
          $(this).addClass('on');
        }
      });
    } else {
      let anchor = $($event.currentTarget);
      anchor.addClass('on');

      mainCategory = $('section.nav-type2').find('ul.main-category').find('li.on').data('category');
    }

    vm.mainCategory2 = mainCategory;
    vm.subCategory2 = subCategory;
    drawChart2(mainCategory, subCategory);
  };

  // 우측 3번째 영역 차트 그리기 함수
  function drawChart2(mainCategory, subCategory) {
    if (!vm.selectedPlayer || !vm.selectedPlayer.detailData || !vm.selectedPlayer.detailData.distance) {
      return;
    }

    switch (mainCategory) {
      case 'distance':
        vm.subCategory2Value = vm.selectedPlayer.detailData.distance[0][subCategory];
        vm.subCategory2Unit = 'km';
        break;

      case 'velocity':
        vm.subCategory2Value = vm.selectedPlayer.detailData.velocity[0][subCategory];
        vm.subCategory2Unit = 'm/s';
        break;

      case 'calory':
        vm.subCategory2Value = vm.selectedPlayer.detailData.calrorie_burned[0][subCategory];
        vm.subCategory2Unit = 'kcal';
        break;

      case 'weight':
        vm.subCategory2Value = vm.selectedPlayer.detailData.weight[0][subCategory];
        vm.subCategory2Unit = 'km';
        break;

      case 'injury':
        vm.subCategory2Value = vm.selectedPlayer.detailData.injury[0][subCategory].day;
        vm.subCategory2Unit = 'day';
        break;
    }

    switch (subCategory) {
      case 'max':
        vm.subCategory2Text = '최대';
        break;

      case 'average':
        vm.subCategory2Text = '평균';
        break;

      case 'recovery':
        vm.subCategory2Text = '회복';
        break;

      case 'reach':
        vm.subCategory2Text = '도달';
        break;

      case 'norm':
        vm.subCategory2Text = '정상';
        break;

      case 'cure':
        vm.subCategory2Text = '치료';
        break;

      case 'operation':
        vm.subCategory2Text = '수술';
        break;

      case 'current':
        vm.subCategory2Text = '현재';
        break;
    }
  }

  $scope.$on('$viewContentLoaded', function (event) {
    // 우측 상단 버튼 클릭 (경기관리 이동 제외)
    let topButtons = $('.top_icons').find('button').not('.game');
    topButtons.on('click', function () {
      topButtons.removeClass('on');
      $(this).addClass('on');

      if (!$(this).hasClass('movement')) {
        vm.showMapSelectBox = false;
      }
    });

    // 우측 polar chart 그리기
    /*
    Highcharts.chart('polar-chart', {

      chart: {
        polar: true,
        type: 'area',
        backgroundColor: 'transparent',
        margin: [10, 0, 0, 0]
      },

      credits: {
        enabled: false
      },

      title: {
        text: ''
      },

      pane: {
        size: '80%'
      },

      xAxis: {
        categories: ['심박수', '거리', '칼로리', '체온', '속도'],
        tickmarkPlacement: 'on',
        lineWidth: 0,
        labels: {
          style: {
            fontWeight: 'bold',
            fontSize: '13px',
            color: '#ffffff'
          }
        }
      },

      yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
        tickInterval: 10,
        labels: {
          enabled: false
        }
      },

      tooltip: {
        enabled: false
      },

      legend: {
        enabled: false
      },

      plotOptions: {
        area: {
          fillOpacity: 0.2
        }
      },

      series: [{
        name: 'Allocated Budget',
        data: [9, 8, 6, 7, 8],
        pointPlacement: 'on'
      }]

    });*/
  });

  vm.gamePlayTimer = function () {
    let elem = document.getElementById("myBar");
    let width = 1;
    let id = setInterval(frame, 1000);

    function frame() {
      if (width >= 100) {
        clearInterval(id);
      } else {
        width++;
        elem.style.width = width + '%';
      }
    }
  };


}

export default {
  name: 'LocationCtrl',
  fn: LocationCtrl
};
